<div
	#content
	[ngClass]="{
		'line-clamp-6': !expanded(),
	}"
>
	<ng-content />
</div>
@if (showToggle()) {
	<button
		(click)="toggle()"
		class="mt-2 text-link"
		data-test-id="toggle-read-more"
	>
		{{ (expanded() ? 'global.read-less' : 'global.read-more') | translate }}
	</button>
}
